import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet} from 'react-native';

export default (props: ITheme) => {
  return StyleSheet.create({
    container: {
      marginTop: 12,
    },
    touchableContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    image: {
      width: 32,
      height: 32,
      borderRadius: 16,
      marginRight: 8,
    },
    arrowImage: {
      width: 16,
      height: 16,
    },
    userContent: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
    },
    hiddenContent: {
      position: 'absolute',
      boxShadow: `1px 1px 10px ${props.colors.shadowGrey}`,
      backgroundColor: props.colors.white,
      right: 0,
      top: 50,
      borderRadius: 8,
    },
    fullName: {
      ...props.typography.interMedium,
      fontSize: 14,
      marginBottom: 12,
    },
    textContainer: {
      marginLeft: 12,
      marginVertical: 10,
    },
    email: {
      ...props.typography.interMedium,
      fontSize: 14,
      color: props.colors.gray,
    },
    spacer: {
      height: 1,
      width: '100%',
      backgroundColor: props.colors.purple(0.13),
    },
    bottomSpacer: {
      height: 1,
      width: '100%',
      backgroundColor: props.colors.purple(0.13),
      marginTop: 7,
      marginBottom: 12,
    },
  });
};
